"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableStyles = void 0;
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
exports.tableStyles = {
    table: react_1.css({
        width: '100%',
        background: 'white',
        borderCollapse: 'collapse',
        borderRadius: style_1.pxToRem(8),
        boxShadow: "0px 0px 0px 1px " + style_1.DesignSystemColor.Gray.LIGHT_3,
    }),
    header: react_1.css({
        padding: style_1.pxToRem(12) + " " + style_1.pxToRem(16),
        color: style_1.SixsenseColor.Gray.DEFAULT,
        fontWeight: 600,
        fontSize: style_1.pxToRem(14),
        textAlign: 'left',
        lineHeight: '150%',
        borderBottom: "0.5px solid " + style_1.DesignSystemColor.Gray.LIGHT_3,
        '&:hover': {
            background: style_1.DesignSystemColor.Gray.LIGHT_5,
        },
    }),
    row: function (selected) { return react_1.css({
        borderBottom: "0.5px solid " + style_1.DesignSystemColor.Gray.LIGHT_3,
        background: selected ? style_1.DesignSystemColor.Blue.LIGHT_6 : '',
        '&:hover': {
            background: selected ? style_1.DesignSystemColor.Blue.LIGHT_6 : style_1.DesignSystemColor.Gray.LIGHT_5,
        },
        '&:last-child': {
            borderBottom: 'none',
        },
    }); },
    headerContainer: react_1.css({
        display: 'flex',
        alignItems: 'center',
    }),
    data: function (size) { return react_1.css({
        color: style_1.SixsenseColor.Gray.DEFAULT,
        padding: style_1.pxToRem(size === 'small' ? 8 : 16) + " " + style_1.pxToRem(16),
        fontWeight: 400,
        fontSize: style_1.pxToRem(14),
        height: style_1.pxToRem(size === 'small' ? 48 : 60),
        overflow: 'hidden',
    }); },
    sortContainer: react_1.css({
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: style_1.pxToRem(5),
        cursor: 'pointer',
    }),
    icon: function (isSelected) { return react_1.css({
        color: isSelected ? style_1.SixsenseColor.Gray.DARK_4
            : style_1.SixsenseColor.Gray.LIGHT_2,
        fontSize: style_1.pxToRem(14),
        height: style_1.pxToRem(13),
        width: style_1.pxToRem(13),
    }); },
    iconDown: react_1.css({
        marginLeft: '-6px',
    }),
    emptyTd: react_1.css({
        padding: style_1.pxToRem(80),
    }),
    help: react_1.css({
        marginLeft: style_1.pxToRem(5),
    }),
    filter: react_1.css({
        marginLeft: style_1.pxToRem(16),
        height: style_1.pxToRem(13),
        width: style_1.pxToRem(13),
        cursor: 'pointer',
    }),
    checkboxCell: react_1.css({
        width: style_1.pxToRem(20),
    }),
};
exports.default = exports.tableStyles;
